// GENERADO — no editar a mano. Origen: backend/src/oficina/compartido/.
// Regenerar: node scripts/gen-oficina-compartido.mjs

// Modelo y potencia de un contratado (diseño §9.2, D14): los elige Pau; por defecto su última
// elección. La oficina solo RECOMIENDA más potencia con un motivo, nunca bloquea. Código PURO.
import type { Potencia } from './vocabulario.js';
import { POTENCIAS } from './vocabulario.js';

export interface OpcionModelo {
  id: string;
  nombre: string;
}

/** Comprobados en vps1 y vps2 el 27-09-2026 (S0, T0.7). */
export const MODELOS: readonly OpcionModelo[] = [
  { id: 'claude-opus-5-5', nombre: 'Opus 5.5' },
  { id: 'claude-fable-5-1', nombre: 'Fable 5.1' },
  { id: 'claude-sonnet-5', nombre: 'Sonnet 5' },
];

export const PREFERENCIA_INICIAL = { modelo: 'claude-opus-5-5', potencia: 'medium' as Potencia };

export function esPotencia(v: string): v is Potencia {
  return (POTENCIAS as readonly string[]).includes(v);
}
